import axios from 'axios';

export default class Translator {
    private static token = "7c0ea482b25548d488b161bbab0aefdf";
    private static url = "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&to=de";
    static translateToGerman(word: string) {
        const body = [{
            "Text": word
        }];
        return axios.post(this.url, body, {
            headers: {
                'Ocp-Apim-Subscription-Key': this.token
            }
        });
    }
}